import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/myClue",
  },
  {
    path: "/myClue",
    name: "home",
    component: () => import("@/views/layout/index.vue"),
    children: [
      {
        path: "/myClue",
        component: () => import("@/views/myClue/index.vue"),
        meta: {
          title: "我的资源",
        },
      },
      {
        path: "/sellClue",
        component: () => import("@/views/sellClue/index.vue"),
        meta: {
          title: "在售资源",
        },
      },
      {
        path: "/buyClue",
        component: () => import("@/views/buyClue/index.vue"),
        meta: {
          title: "已售资源",
        },
      },
      {
        path: "/passClue",
        component: () => import("@/views/passClue/index.vue"),
        meta: {
          title: "不合格",
        },
      },
      {
        path: "/clueReview",
        component: () => import("@/views/clueReview/index.vue"),
        meta: {
          title: "资源审核",
        },
      },
      {
        path: "/userList",
        component: () => import("@/views/userList/index.vue"),
        meta: {
          title: "小程序用户列表",
        },
      },
      {
        path: "/setuserList",
        component: () => import("@/views/setuserList/index.vue"),
        meta: {
          title: "定制客户列表",
        },
      },
      {
        path: "/revenueList",
        component: () => import("@/views/revenueList/index.vue"),
        meta: {
          title: "营收列表",
        },
      },
      {
        path: "/refundList",
        component: () => import("@/views/refundList/index.vue"),
        meta: {
          title: "提现审核",
        },
      },
      {
        path: "/dataTable",
        component: () => import("@/views/dataTable/index.vue"),
        meta: {
          title: "仪表盘",
        },
      },
      {
        path: "/roleList",
        component: () => import("@/views/roleList/index.vue"),
        meta: {
          title: "角色管理",
        },
      },
      {
        path: "/accountList",
        component: () => import("@/views/accountList/index.vue"),
        meta: {
          title: "账号管理",
        },
      },
      {
        path: "/setting",
        component: () => import("@/views/setting/index.vue"),
        meta: {
          title: "设置",
        },
      },
      {
        path: "/permission",
        component: () => import("@/views/permission/index.vue"),
        meta: {
          title: "权限管理",
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/index.vue"),
    meta: {
      title: "登录",
    },
  },
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.path !== "/login" && !localStorage.getItem("token")) {
    next({ path: "/login" });
  } else {
    next();
  }
});
router.afterEach((to) => {
  document.title = to.meta.title;
});

export default router;
